module.exports = require('./helpers/bundle-url').getBundleURL('8v5FU') + "logo.7718c6df.svg";